import { defineMessages } from "react-intl";

export default defineMessages({
  viewPriceEstimate: {
    id: "contractCard.viewPriceEstimate",
    defaultMessage: "View price estimate",
  },
  offer: {
    id: "contractCard.offer",
    defaultMessage: "<bold>Offer: {offer}</bold>",
  },
  visit: {
    id: "serviceRequest.offerDetail.visit",
    defaultMessage: "Visit",
  },
  forQuote: {
    id: "serviceRequest.offerDetail.forQuote",
    defaultMessage: "for quote",
  },
});
